import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { Product } from '~shared/models';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';

export interface SelectItemApplicationEventPayload {
  pageName: string;
  product: Product;
  priceType: PriceTypes;
  productIndex: number;
  triggerPromotionEvent?: boolean;
  creative_name?: string;
  colorVariantId?: string;
  search_term?: string;
}

export class SelectItemApplicationEventModel implements ApplicationEvent {
  type = ApplicationEventType.SelectItem;

  constructor(
    private pageName: string,
    private product: Product,
    private priceType: PriceTypes,
    private productIndex: number,
    private triggerPromotionEvent?: boolean,
    private creative_name?: string,
    private colorVariantId?: string,
    private searchTerm?: string) {}

  getPayload(): SelectItemApplicationEventPayload {
    return {
      search_term: this.searchTerm,
      pageName: this.pageName,
      product: this.product,
      priceType: this.priceType,
      productIndex: this.productIndex,
      triggerPromotionEvent: this.triggerPromotionEvent,
      creative_name: this.creative_name,
      colorVariantId: this.colorVariantId,
    };
  }
}
